import { render, staticRenderFns } from "./inventoryPriorityConfigModal.vue?vue&type=template&id=95dae288"
import script from "./inventoryPriorityConfigModal.vue?vue&type=script&lang=js"
export * from "./inventoryPriorityConfigModal.vue?vue&type=script&lang=js"
import style0 from "./inventoryPriorityConfigModal.vue?vue&type=style&index=0&id=95dae288&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports